import {reduxForm, change, formValueSelector } from "redux-form";
import { grabAdjustmentLogs } from "../../actions/adjustmentInventory_actions";
import { connect } from 'react-redux';
import AdjustmentLog from '../../components/Inventories/adjustmentLog';

const adjustmentLog = reduxForm({
    form: 'adjustmentLog',
})(AdjustmentLog);

const selector = formValueSelector('adjustmentLog');

function mapStateToProps(state) {
    const limit = selector(state, 'limit');
    return {
        limit,
        logs: state.adjustment.logs,
        isLoading: state.adjustment.isLoading,
        logError: state.adjustment.logError,
    }
}

export default connect(mapStateToProps, {
    grabAdjustmentLogs
})(adjustmentLog)


// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/adjustmentLog.jsx